import React, { useEffect, useState } from 'react';
import './Admin.css';
import { Link, useNavigate } from 'react-router-dom';

const Dashboard = () => {
  const navigate = useNavigate();
  const [activeMembers, setActiveMembers] = useState(0);

  useEffect(() => {
    const role = sessionStorage.getItem("userRole");

    if (!role) {
      navigate("/lfploginadmin");
    }
  }, [navigate]);

  const handleLogout = () => {
    sessionStorage.removeItem("userRole");
    navigate("/lfploginadmin");
  };

  const services = [
    {
      title: "New Admission",
      icon: "📝",
      path: "/services/new-admission"
    },
    {
      title: "Payment",
      icon: "💳",
      path: "/service/payment"
    },
    {
      title: "Mark Attendance",
      icon: "⏰",
      path: "/assis/AttendanceHome"
    },
     {
          title: "Payment Reminder",
          icon: "⏰",
          path: "/assis/PayReminder"
        },
        {
                  title: "Attendance Reminder",
                  icon: "⏰",
                  path: "/assis/AttReminder"
                }
  ];

  // Fetch active members
  useEffect(() => {
    fetch("https://gym-invoice.onrender.com/api/members/active/count")
      .then((res) => res.json())
      .then((data) => setActiveMembers(data))
      .catch((err) =>
        console.error("Error fetching active members:", err)
      );
  }, []);

  return (
    <div className="dashboard">

      <header className="header">

        <div className="logo-wrapper">

          <div className="logo-circle">
            <img
              src={process.env.PUBLIC_URL + "/Images/logo.jpeg"}
              alt="Logo"
              className="header-logo"
            />
          </div>

          <span className="logo-text">
            LIFE FITNESS PARTNER
          </span>

          <span className="logo-arrow">
            »
          </span>

        </div>

        <div className="header-right">
          <button
            className="logout-button"
            onClick={handleLogout}
          >
            Logout
          </button>
        </div>

      </header>

      <section className="services">

        <h3>MANAGER DASHBOARD</h3>

        <div className="service-grid">

          {services.map((service, index) => (
            <Link
              key={index}
              to={service.path}
              className="service-card-link"
            >
              <div className="service-card">

                <div className="icon">
                  {service.icon}
                </div>

                <h4>
                  {service.title}
                </h4>

              </div>
            </Link>
          ))}

        </div>

      </section>

    </div>
  );
};

export default Dashboard;